<template>
	<div id="app">
		<floatTip></floatTip>
		<router-view></router-view>
	</div>
</template>

<script>
	import floatTip from './components/floatTip.vue'
	export default {
		name: 'App',
		components: {
			floatTip
		}
	}
</script>
<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
	}

	body {
		background: linear-gradient(to bottom, #e2efff 0%, #fff 100%)
	}

	/**滚动条的宽度*/
	::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}

	/*滚动条的滑块*/
	::-webkit-scrollbar-thumb {
		background-color: rgb(185, 221, 255);
		border-radius: 5px;
	}

	::-webkit-scrollbar-thumb:hover {
		background: rgba(24, 144, 255, .8);
	}
</style>
